import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { SalesApiService } from '../../services/sales-api.service';

/**
 * 
 * */
@Component({
  selector: 'campfire-willner-page',
  templateUrl: './willner.page.component.html',
  styleUrls: ['./willner.page.component.scss']
})
export class WillnerPageComponent implements OnInit {
  ngOnInit() {
    window.location.href = 'https://campfire.rangegroup.com/willner';
  }
}

